import { createStyles } from "@mantine/core";
const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  btn: {
    marginLeft: "auto",
    marginTop: 50,
  },
  accordionControl: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  // mymodal: {
  //   width: "100%",
  //   overflow: "visible",
  //   "& .mantine-Modal-content": {
  //     // overflowY: "visible !important"

  //   },
  //   "& .mantine-Modal-inner": {
  //     padding: "px !important",
  //   },
  //   "& .mantine-Modal-header": {
  //     zIndex: 100,
  //   },
  // mymodal: {
  //   "& .mantine-Drawer-content": {
  //     borderRadius: "20px !important",
  //     // margin: "20px 20px 40px 0px",
  //     // backgroundColor: "#E5E5E5",
  //   },
  //   width: "100%",
  //   margin: "10px",
  //   overflow: "auto",
  //   height: "100%",
  //   borderRadius: "1rem 1rem 1rem 1rem",
  //   boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",

  //   // "& .mantine-Modal-content": {
  //   //   height: "300px !important",
  //   // },
  //   // "& .mantine-Modal-inner": {
  //   //   padding: "0px !important",
  //   // },
  //   "& .mantine-Paper-root": {
  //     overflow: "initial !important",
  //   },
  //   "& .mantine-Modal-inner": {
  //     // padding: "0px !important",
  //   },
  //   "& .mantine-Modal-header": {
  //     display: "none",
  //   },
  //   "& .mantine-Modal-body": {
  //     height: "90vh ",
  //     overflowY: "auto",
  //     padding: "0",
  //     background: "#F2F2F2",
  //     borderRadius: "1rem",
  //     // "@media (min-width: 2560px)": {
  //     //   height: "80vh !important",
  //     // },
  //   },

  //   "@media (max-width:400px)": {
  //     width: "auto",
  //   },
  //   "& .mantine-1q36a81": {
  //     padding: "0",
  //   },
  //   // "@media (max-width: 400px)": {
  //   //   width: "auto",
  //   // },
  //   // "@media (min-width: 1440px)": {
  //   //   height: "50vh",
  //   // },
  //   // "@media (min-width: 1920px)": {
  //   //   height: "45vh",
  //   // },
  //   // "@media (max-width: 2560px)": {
  //   //   minHeight: "100vh !important",
  //   // },
  // },

  mymodal: {
    "& .mantine-Drawer-header": {
      backgroundColor: "#FFF",
      padding: "19px 13px",
      "& .mantine-CloseButton-root svg": {
        height: "20px !important",
        width: "20px !important",
      },
    },
    "& .mantine-Drawer-body": {
      padding: "29px 24px !important",
    },
    "& .mantine-Drawer-title": {
      fontSize: "24px",
      fontWeight: "700",
      color: "#000",
      fontFamily: "Inter",
    },
    "& .mantine-Drawer-content": {
      borderRadius: "13px !important",
      backgroundColor: "#F5F5F5",
    },
    width: "100%",
    margin: "10px",
    overflow: "auto",
    height: "100%",
    "& .mantine-1as9nn9": {
      backgroundColor: "rgba(0, 0, 0, 0.1) !important",
    },

    "& .mantine-Drawer-inner": {
      right: 0,
      // top:15,
      // right:15,
      // "& section": {
      //   height:'calc(100% - 20px) !important',

      //   "& .mantine-1deqy7c":{
      //     height:'100% !important'
      //   }
      // },
    },

    // borderRadius: "1rem 1rem 1rem 1rem",
    // boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
    // "& .mantine-Modal-content": {
    //   height: "300px !important",
    // },
    // "& .mantine-Modal-inner": {
    //   padding: "0px !important",
    // },

    "& .mantine-ScrollArea-viewport": {
      background: "#F2F2F2",
    },
    // "& .mantine-Paper-root": {
    //   overflow: "initial !important",
    // },
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
    "& .mantine-Modal-header": {
      // display: "inline",
      borderRadius: "15px",
    },
    "& .mantine-Modal-body": {
      // height: "90vh ",
      overflowY: "auto",
      // padding: "0",
      background: "#F2F2F2",
      borderRadius: "1rem",
      // "@media (min-width: 2560px)": {
      //   height: "80vh !important",
      // },
    },

    "@media (max-width:400px)": {
      width: "auto",
    },
    "& .mantine-1q36a81": {
      padding: "0",
    },
    // "@media (max-width: 400px)": {
    //   width: "auto",
    // },
    // "@media (min-width: 1440px)": {
    //   height: "50vh",
    // },
    // "@media (min-width: 1920px)": {
    //   height: "45vh",
    // },
    // "@media (max-width: 2560px)": {
    //   minHeight: "100vh !important",
    // },
  },

  noteType: {
    padding: "12px 12px 20px 12px !important",
    borderRadius: "8px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
    "& .mantine-Select-root": {
      fontFamily: "Inter",
      "& .mantine-Select-label": {
        color: "#344054",
        fontSize: "14px",
        fontWeight: 500,
        width: "100%",
        textAlign: "start",
      },
      "& .mantine-Select-wrapper": {
        marginTop: "8px",
        height: "auto",
        backgroundColor: "#FFFFFF",
        borderRadius: "8px",
        border: "1px solid #E5E5E5",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      },
      "& input": {
        border: "none",
        backgroundColor: "transparent",
        paddingBlock: "10px",
        color: "#0F172A",
        fontSize: "14px",
        fontWeight: 400,
        paddingLeft: "14px",
        height: "44px",
      },
      "& .mantine-Select-rightSection": {
        width: "fit-content",
        height: "inherit",
        marginRight: "14px",
      },
    },
  },

  select: {
    fontFamily: "Inter",
    "& .mantine-Select-label": {
      color: "#344054",
      fontSize: "14px",
      fontWeight: 500,
      fontFamily: "Inter",
      width: "100%",
      textAlign: "start",
    },
    "& .mantine-Select-wrapper": {
      marginTop: "8px",
      height: "auto",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    },
    "& input": {
      border: "none",
      backgroundColor: "transparent",
      paddingBlock: "10px",
      color: "#0F172A",
      fontSize: "14px",
      fontWeight: 400,
      paddingLeft: "14px",
      height: "44px",
    },
    "& .mantine-Select-rightSection": {
      width: "fit-content",
      height: "inherit",
      marginRight: "14px",
    },
  },
  input: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        fontFamily: "Inter",
        color: "#0F172A",
        fontSize: "14px",
        fontWeight: 400,
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#344054",
      marginBottom: "8px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      width: "100%",
      textAlign: "start",
    },
  },
  view_input: {
    "& .mantine-InputWrapper-label": {
      color: "#344054",
      marginBottom: "3px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      width: "100%",
      textAlign: "start",
    },
  },
  outcomeDeleteBTN: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "flex-end",
    borderRadius: "8px",
    background: "#FAFAFA",
    padding: "8px",
    "& .mantine-Text-root": {
      padding: "8px 0px",
      display: "flex",
      alignItems: "center",
      fontWeight: 600,
      gap: 4,
      fontSize: "16px",
      color: "#F04438",
      cursor: "pointer",
      fontFamily: "Inter",
    },
  },
  goalsTextArea: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      borderRadius: "8px 8px 8px 8px",
      padding: "10px 0 10px",
      backgroundColor: "#FFF",
      border: "1px solid #D0D5DD",
      boxShadow:
        "0px -1px 2px 0px rgba(16, 24, 40, 0.05), -1px 0px 2px 0px rgba(16, 24, 40, 0.05), 1px 0px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        borderRadius: "8px 8px 0px 0px",
        fontFamily: "Inter",
        padding: "0 10px",
        border: "none",
        color: "#737373",
        fontSize: "12px",
        fontWeight: 400,
        height: "150px",
        textAlign: "justify",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#344054",
      marginBottom: "8px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  essentialDiscriptionArea: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      borderRadius: "8px 8px 0px 0px",
      padding: "10px 0 10px",
      backgroundColor: "#FFF",
      border: "1px solid #D0D5DD",
      boxShadow:
        "0px -1px 2px 0px rgba(16, 24, 40, 0.05), -1px 0px 2px 0px rgba(16, 24, 40, 0.05), 1px 0px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        borderRadius: "8px 8px 0px 0px",
        fontFamily: "Inter",
        padding: "0 10px",
        border: "none",
        color: "#737373",
        fontSize: "12px",
        fontWeight: 400,
        height: "150px",
        textAlign: "justify",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#344054",
      marginBottom: "8px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  essentialViewInfoAccordion: {
    marginBottom: "26px !important",
    borderRadius: 8,
    background: "rgba(247, 247, 247, 0.60)",
    "& .mantine-Accordion-label": {
      display: "flex",
      alignItems: "center",
      gap: 7,
      color: "#000",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 400,
      "& svg": {
        height: "18px",
        width: "18px",
        marginBottom: "0px !important",
      },
    },
    "& .mantine-Accordion-chevron svg": {
      color: "#000",
    },
  },
  datePicker: {
    fontFamily: "Inter",
    "& .mantine-Input-wrapper": {
      marginTop: "8px",
      height: "auto",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",

      "& .mantine-DatePickerInput-input": {
        padding: "10px 14px",
      },
      "& .mantine-Input-input": {
        backgroundColor: "transparent",
        border: "none",
        height: "44px",
        color: "#262626",
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: 600,
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#344054",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  approved: {
    backgroundColor: "#ECFDF3",
  },
  rejected: {
    background: "#FEF3F2",
  },
  pending: {
    background: "#fff",
  },
  mwd: {
    // background: "red",
    width: "100%",
    textAlign: "start",
    "& .mantine-Modal-header": {
      zIndex: 100,
    },
    "@media (max-width: 600px)": {
      width: "100% !important",
      flexDirection: "column",
    },
  },
  essentialAccordion: {
    "& .mantine-Accordion-content": {
      padding: "26px 14px 28px 14px",
    },
  },
  myfont: {
    fontFamily: "Inter",
    overflow: "auto",

    "& .mantine-Textarea-input": {
      background: "#FAFAFA",
      color: "#737373",
    },
  },
  disabledTextarea: {
    overflowY: "auto",
    resize: "none",
    cursor: "not-allowed",
    // backgroundColor: "red",
  },
  viewTextArea: {
    minHeight: "100px",
    height: "100px",
  },
  descriptionIcon: {
    position: "absolute",
    top: 10,
    left: 10,
  },
  labelTextarea: {
    fontWeight: "500",
    paddingBottom: "10px",
    margin: "0 !important",
  },
  infoLabel: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  // header: {
  //   width: "100%",
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   background: "#f4ead8",
  //   overflow: "hidden",
  //   borderRadius: "1rem 1rem 0 0",
  //   height: "80px",
  //   gap: "20px",
  //   "& h2": {
  //     margin: "0",
  //     fontSize: "20px",
  //   },
  // },
  newDesignHeader: {
    width: "100%",
    display: "flex",
    paddingLeft: "20px",
    alignItems: "center",
    background: "#ffffff",
    overflow: "hidden",
    borderRadius: "1rem 1rem 0 0",
    height: "80px",
    gap: "20px",
    "& h2": {
      margin: "0",
      fontSize: "20px",
    },
  },
  modalTopHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
  },
  staffContainer: {
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
    width: "100%",
    // gap: "5px",
  },

  userDetails: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
    // padding: "0 1rem",
  },
  textInputBox: {
    backgroundColor: "#fff",
    width: "100%",
    marginTop: "10px",
    border: "1px solid rgba(0,0,0,0.1)",
    padding: "5px 15px",
    borderRadius: "15px",
    position: "relative",
    "& textarea[disabled]": {
      backgroundColor: "#fff !important",
    },
    "& .mantine-Textarea-input": {
      border: "none",
      paddingInline: "0",
    },
    "& .label": {
      position: "absolute",
      borderRadius: "5px",
      top: -10,
      left: 15,
      zIndex: 100,
      color: "#000",
      margin: 0,
      backgroundColor: "#fff",
      display: "inline-block",
      fontSize: "14px",
      fontWeight: 500,
      paddingInline: "10px",
    },
  },
  modalContentBG: {
    borderRadius: "1rem",
    margin: "1rem 0",
    // width:"calc(100% - 2.5rem)",
    // boxSizing:'border-box'
  },
  accordionTitle: {
    background: "#F2F2F2",
    padding: ".5rem",
    borderRadius: "5px",
  },
  accordionItem: {
    background: "#fcfcfc",
    // borderTopLeftRadius: "10px",
    // borderTopRightRadius: "10px",
    borderRadius: "10px",
    borderBottom: "none !important",
    position: "relative",
    paddingTop: "10px",
    "& .mantine-hp9ccp[data-active=true]": {
      // borderRadius: "10px !important",
      position: "absolute",
      width: "fit-content",
      right: 0,
    },
    // "& .accordionCon": {
    //   // borderRadius: "10px !important",
    //   position:"absolute"
    // },
  },
  addNoteAccordionItem: {
    "& .mantine-hp9ccp[data-active=true]": {
      // borderRadius: "10px !important",
      position: "static",
      width: "100%",

      "& ..mantine-p2utts": {
        display: "none",
      },
    },
  },
  essentialAccordionItem: {
    background: "#fff",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    boxShadow: `rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px`,
  },
  howOftenClass: {
    border: "1px solid #F2F2F2",
    padding: "0 .5rem",
    borderRadius: "10px",
    marginBottom: "1rem",
    marginTop: ".3rem",
    width: "350px",
  },
  accordionInput: {
    border: "1px solid #F2F2F2",
    padding: "0 .5rem",
    borderRadius: "10px",
    height: "fit-content",
    marginBottom: "1rem",
    marginTop: ".3rem",
    width: "100%",
    // overflowY: "auto",
    // height: "150px",
  },
  activityContainer: {
    display: "flex",
    justifyContent: "center",
    // alignItems: "center",
    gap: "10px",
    width: "100%",
    height: "100%",
  },
  radioGroup: {
    border: "1px solid #F2F2F2",
    borderRadius: "10px",
  },
  selectBG: {
    padding: "5px",
    borderRadius: "5px",
    width: "100%",

    "& .mantine-1ejqehl .mantine-Input-wrapper input": {
      fontWeight: "900",
      background: "red",
    },
  },
  accordionRowWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  accordionRowSingleLine: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },

  accordionRowSingleLineText: {
    flex: 1,
  },

  accordianSingleLineBox: {
    width: '100%',
  },
  infoAccordion: {
    height: "250px",
    overflowY: "auto",
  },
  outcomeText: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    color: "#212529",
  },
  outcomeContainer: {
    // background: "#f1f3f5",
    padding: "5px",
    borderRadius: "5px",
    marginTop: "3px",
    width: "100%",
  },
  staffOnEdit: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  responsiveBtn: {
    "@media (min-width:992px)": {
      display: "block",
      marginLeft: "auto",
    },
    "@media (max-width:992px)": {
      display: "block",
      margin: "0 auto",
      width: "50%",
    },
  },

  essentialResponsiveBtn: {
    marginLeft: "auto",
    display: "block",
    marginTop: "10px",
    borderRadius: "8px",
    backgroundColor: "#eeaa33",
    color: "#000000",
    "@media (min-width:992px)": {
      display: "block",
      marginLeft: "auto",
    },
    "@media (max-width:992px)": {
      display: "block",
      margin: "0 auto",
      width: "50%",
    },
  },
  cancelAndSupportParent: {
    margin: "0 16px 0 16px",
  },
  saveAndCancelParent: {
    backgroundColor: "red",
    width: "100%",
  },
  saveNoteBtn: {
    margin: "5px 5px 0 5px",
    width: "48%",
    backgroundColor: "#FFAF4A",
    color: "#000000",
    borderRadius: "8px",
    padding: "10px 0",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    height: "auto",
    border: "1px solid #FFAF4A",
    fontFamily: "Inter",
    fontSize: "18px",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#fab005 !important",
    },
    "@media (max-width: 600px)": {
      fontSize: "14px",
    },
  },
  cancelNoteBtn: {
    margin: "5px 5px 0 5px",
    width: "48%",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    padding: "16px 28px",
    border: "1px solid #F5F5F5",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    color: "#262626",
    fontFamily: "Inter",
    fontSize: "18px",
    fontWeight: 600,
    height: "auto",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    "@media (max-width: 600px)": {
      fontSize: "14px",
    },
  },
  essentialSupportParent: {
    borderRadius: "10px",
    margin: "1rem",
    padding: "1rem",
    background: "#fff",
  },
  rejectionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    justifyContent: "end",
    alignItems: "flex-end",
    // margin: "0 1rem",
  },
  rejectionBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: ".5rem",
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5EA",
    borderWidth: "2px",
    borderStyle: "solid",
  },
  rejection: {
    backgroundColor: "#FEF3F2",
    borderRadius: "10px",
    padding: "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
  },
  crossIcon: {
    cursor: "pointer",
  },
  rejectedNote: {
    display: "flex",
    flexDirection: "column",
    // alignItems: "center",
    gap: ".5rem",
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5EA",
    borderWidth: "2px",
    margin: "1rem 0",
  },
  approvedNote: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: ".5rem",
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5EA",
    borderWidth: "2px",
    margin: "1rem 1rem",
  },
  btns: {
    display: "flex",
    gap: "1rem",
    justifyContent: "flex-end",
    margin: "1rem",
  },
  rejectionIconBox: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",
  },
  rejectionBoxReason: {
    display: "flex",
    flexDirection: "column",
    gap: ".3rem",
    alignContent: "start",
    justifyContent: "start",
  },
  // staffField: {
  //   margin: "0 20px",
  // },
  outcomeTitle: {
    background: "#F5F5F5",
    padding: "10px",
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: "16px",
    margin: "10px 0",
    justifyContent: "space-between",
    border: "1px solid #E7EBEF",
  },
  outcomeTitleView: {
    background: "#fff",
    padding: "10px",
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: "16px",
    // margin: "10px 0",
    justifyContent: "space-between",
    border: "1px solid #E7EBEF",
  },
  outcomeNote: {
    background: "#F5F5F5",
    padding: "10px",
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: "16px",
    margin: "10px 0",
    height: "200px",
    overflowY: "scroll",
    border: "1px solid #E7EBEF",
  },
  accordionDeleteBtn: {
    backgroundColor: "transparent",
    color: "red",
    border: "none",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  deleteIcon: {
    marginRight: "5px",
  },
  deleteBtnParent: {
    backgroundColor: "#f7f7f7",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "flex-end",
  },
  addNewOutcomeBtn: {
    backgroundColor: "#F5F5F5",
    color: "#000000",
    width: "50%",
    height: "40px",
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  progressNoteSaveBtn: {
    backgroundColor: "#FFAF4A",
    color: "#000000",
    width: "50%",
    height: "40px",
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: "#FFAF4A",
    },
  },
  textAreaStyling: {
    width: "100% !important",
    borderRadius: "10px",
  },
  groupedButtonsParent: {
    backgroundColor: "#ffffff",
    // margin: "0 16px 0 16px",
    padding: "10px",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    borderTop: "1px solid #E5E5E5",
    boxShadow: `rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px`,
    display: "flex",
  },
  supportPlanGroupedButtons: {
    backgroundColor: "#ffffff",
    padding: "10px",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    borderTop: "1px solid #E5E5E5",
    boxShadow: `rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px`,
    marginBottom: "10px",
    display: "flex",
  },
  detailsForm: {
    backgroundColor: "#FFF",
    borderRadius: "16px",
    border: "1px solid #E5E5E5",
    padding: "20px 13px 19px 13px",
  },
  radioGroupParent: {
    "& .mantine-Text-root": {
      color: "#344054",
      fontSize: "14px",
      fontWeight: 500,
      fontFamily: "Inter",
      marginBottom: "11px",
    },
    "& .radioGroupStyling": {
      border: "1px solid #ccc",
      padding: "12px",
      borderRadius: "7px",
      marginTop: "1px",
      height: "44px",
      backgroundColor: "#FAFAFA",
      "& .mantine-Radio-label": {
        color: "#000",
        fontSize: "14px",
        fontFamily: "Inter",
        fontWeight: 500,
      },
      "& .mantine-Radio-radio:checked": {
        backgroundColor: "#000",
        borderColor: "#000",
      },
    },
  },
  supportPlanAccordion: {
    maxHeight: "100%",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    boxShadow: `rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px`,
    margin: "18px 15px 15px 15px",
  },
  noteTypeCompParent: {
    margin: "15px 22px 10px 14px",
  },
  noteSelected: {
    margin: "15px 12px 10px 14px",
  },
  fontSizeClass: {
    textAlign: "start",
    "& .mantine-1lflqwz,.mantine-1pykq1x": {
      fontWeight: 600,
    },
    '& .mantine-1urhmm0':{
      fontWeight: 400,
      fontSize: 12
    }
  },
  my: {
    margin: "2rem 0",
  },
  noteViewNewDrawer: {
    // "& .mantine-Drawer-header": {
    //   backgroundColor: "#FFF",
    //   padding: "19px 13px",
    //   "& .mantine-CloseButton-root svg": {
    //     height: "20px !important",
    //     width: "20px !important",
    //   },
    // },
    "& .mantine-Drawer-body": {
      padding: "0px !important",
    },
    "& .mantine-Drawer-title": {
      fontSize: "24px",
      fontWeight: "700",
      color: "#000",
      fontFamily: "Inter",
    },
    "& .mantine-Drawer-content": {
      borderRadius: "13px !important",
      backgroundColor: "#F5F5F5",
    },
    width: "100%",
    margin: "10px",
    overflow: "auto",
    height: "100%",
    "& .mantine-1as9nn9": {
      backgroundColor: "rgba(0, 0, 0, 0.1) !important",
    },

    "& .mantine-Drawer-inner": {
      right: 0,
    },
  },
  timeDateView: {
    "& .mantine-Input-input": {
      minHeight: "auto",
      height: "auto",
      lineHeight: "normal",
      color: "#262626",
      fontSize: 14,
      fontWeight: 600,
      fontFamily: "Inter",
      padding: 0,
    },
    "& .mantine-InputWrapper-label": {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: 400,
      color: "#737373",
    },
  },
  waveSection: {
    marginTop: theme.spacing.md,
    padding: theme.spacing.md,
    // backgroundColor: "#F9FAFB",
    // border: "1px solid #D0D5DD",
    // borderRadius: 8,
  },

  wave: {
    display: "flex",
    alignItems: "end",
    gap: 4,
    height: 50,
    marginBottom: theme.spacing.md,
  },

  bar: {
    width: 4,
    borderRadius: 2,
    backgroundColor: "#FFAF4A",
    animation: "wave 1.2s infinite ease-in-out",
  },

  "@keyframes wave": {
    "0%, 100%": { height: "60%" },
    "50%": { height: "100%" },
  },

  waveButtons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
  },
  signatureImg: {
    width: 250,
    height: "auto",
    marginTop: 20,
  },
  interventionGoalItem: {
    border: "1px solid #D0D5DD",
    padding: 10,
    borderRadius: 8,
  },
  interventionAddGoalItem: {
    display: "flex",
    width: 26,
    height: 26,
    padding: 0,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 35,
    backgroundColor: "#FFF",
    boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.25)",
    "&:hover": {
      backgroundColor: "#FFF",
    },
  },
  goalItemsBox: {
    border: "1px solid #E0E0E0",
    padding: "10px",
    marginTop: "10px",
    borderRadius: "8px",
    textAlign: "justify"
  },
}));

export default useStyles;
